import InactiveAccountLogin from './InactiveAccountLogin';

export default InactiveAccountLogin;
